// @flow
import type { Element } from 'react';

import React from 'react';
import { FormGroup, Col, Row, Label } from 'reactstrap';
import {
  NUMBER_OF_STORIES,
  NUMBER_OF_SUBGRADE_STORIES,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import FieldVisibilityToggle from '#components/pages/Models/Model/sections/support/forms/FieldVisibilityToggle/index.js';
import Field from '#components/pages/Models/Model/sections/support/forms/Field/index.js';
import Tip from '#components/support/tooltips/Tip/index.jsx';
import { FieldFeedback, RenderInput } from '#components/support/forms/utility/index.js';
import NumberOfStoriesWarning from './NumberOfStoriesWarning/index.js';

type Props = {|
  form: string,
  showSubgradeStories: boolean,
|};

const StoriesFieldSet = ({ form, showSubgradeStories }: Props): Element<typeof FormGroup> => (
  <FormGroup tag="fieldset">
    <legend>Stories</legend>
    <Row className="">
      <Col>
        <FieldVisibilityToggle
          className="float-right define-subgrade-toggle"
          form={form}
          on={showSubgradeStories}
          onFields={[NUMBER_OF_SUBGRADE_STORIES]}
          onText="Superstructure Only"
          offFields={[]}
          offText="Include Subgrade"
        />
      </Col>
    </Row>
    <Row className="mt-0">
      <Col lg="4">
        <FormGroup className="mt-0">
          <Label htmlFor={NUMBER_OF_STORIES}>
            Number of Stories <Tip tipId={NUMBER_OF_STORIES} />
          </Label>
          <Field
            form={form}
            id={NUMBER_OF_STORIES}
            name={NUMBER_OF_STORIES}
            type="text"
            component={RenderInput}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row className="mt-n3 mb-3">
      <Col lg="12">
        {/* FieldFeedback moved for better wrapping */}
        <FieldFeedback name={NUMBER_OF_STORIES} form={form} />
        <NumberOfStoriesWarning form={form} />
      </Col>
    </Row>
    {showSubgradeStories && (
      <Row>
        <Col lg="4">
          <FormGroup>
            <Label htmlFor={NUMBER_OF_SUBGRADE_STORIES}>
              No. Subgrade Levels <Tip tipId={NUMBER_OF_SUBGRADE_STORIES} />
            </Label>
            <Field
              form={form}
              id={NUMBER_OF_SUBGRADE_STORIES}
              name={NUMBER_OF_SUBGRADE_STORIES}
              type="text"
              component={RenderInput}
            />
            <FieldFeedback name={NUMBER_OF_SUBGRADE_STORIES} form={form} />
          </FormGroup>
        </Col>
      </Row>
    )}
  </FormGroup>
);

export default StoriesFieldSet;
